<template>
<div class="ft-root" :style="themePageStyle">

  <nav class="ft-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <a href="javascript:void(0)" @click="$router.push('/forum')"><i class="mdi mdi-arrow-left" style="color:var(--fm-m,#A09888);font-size:22px;"></i></a>
      <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:30px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:14px;">Forum</span>
    </div>
    <button class="btn btn-sm btn-warning" @click="$router.push('/forum')"><i class="mdi mdi-forum me-1"></i>All Topics</button>
  </div></nav>

  <div class="container ft-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <div v-else-if="!topic" class="text-center py-5">
      <i class="mdi mdi-forum-remove" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
      <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">Topic not found</h5>
      <button class="btn btn-warning" @click="$router.push('/forum')">Back to Forum</button>
    </div>

    <div v-else>
      <!-- Topic header -->
      <div class="ft-topic">
        <div class="d-flex justify-content-between align-items-start gap-2">
          <div style="flex:1;min-width:0;">
            <div class="ft-cat-row">
              <span class="ft-cat">{{ topic.category }}</span>
              <span v-if="topic.species_name" style="color:var(--fm-s,#6B6356);font-size:11px;">· {{ topic.species_name }}</span>
              <span v-if="topic.is_pinned == 1" class="ft-pin"><i class="mdi mdi-pin"></i> pinned</span>
              <span v-if="topic.status === 'closed'" class="ft-closed"><i class="mdi mdi-lock"></i> closed</span>
              <span v-if="topic.is_answered == 1" class="ft-answered"><i class="mdi mdi-check-decagram"></i> answered</span>
            </div>
            <h2 class="ft-title">{{ topic.title }}</h2>
          </div>
        </div>
        <div class="ft-author">
          <user-avatar :src="topic.author_avatar" :name="topic.author_name" size="md" />
          <div>
            <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;">{{ topic.author_name && topic.author_name.trim() ? topic.author_name : 'Anonymous farmer' }}</div>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;">{{ topic.created_at }}</div>
          </div>
        </div>
        <div class="ft-content">{{ topic.content }}</div>

        <!-- Topic media (images + videos) -->
        <div v-if="topicVisualMedia.length" class="ft-media-grid">
          <div v-for="(m, mi) in topicVisualMedia" :key="'tm-'+mi" class="ft-media-display">
            <img v-if="m.type === 'image'" :src="mediaUrl(m.url)" @click="openLightbox(m)" />
            <video v-else :src="mediaUrl(m.url)" controls></video>
          </div>
        </div>
        <!-- Topic documents -->
        <div v-if="topicDocs.length" class="ft-doc-list">
          <a v-for="(d, di) in topicDocs" :key="'td-'+di" :href="mediaUrl(d.url)" target="_blank" class="ft-doc-link">
            <i class="mdi" :class="docIcon(d.name || d.url)"></i>
            <div style="flex:1;min-width:0;">
              <div class="ft-doc-link-name">{{ d.name || 'Document' }}</div>
              <div class="ft-doc-link-size" v-if="d.size">{{ humanSize(d.size) }}</div>
            </div>
            <i class="mdi mdi-download" style="color:var(--fm-s,#6B6356);"></i>
          </a>
        </div>

        <div class="ft-stats">
          <span v-if="topic.location_label" style="color:#50C878;"><i class="mdi mdi-map-marker me-1"></i>{{ topic.location_label }}</span>
          <span><i class="mdi mdi-eye-outline me-1"></i>{{ topic.view_count }} views</span>
          <span><i class="mdi mdi-message-reply-text-outline me-1"></i>{{ topic.reply_count }} replies</span>
        </div>
      </div>

      <!-- Replies -->
      <h6 style="color:var(--fm-h,#F5F0E8);margin-top:30px;"><i class="mdi mdi-message-reply-text me-1" style="color:#BFA164;"></i>{{ posts.length }} {{ posts.length === 1 ? 'reply' : 'replies' }}</h6>

      <div v-for="p in posts" :key="p.id" class="ft-post" :class="{accepted: p.is_accepted_answer == 1}">
        <div class="ft-vote">
          <button class="ft-vote-btn" :class="{up: voteState[p.id] === 'up'}" @click="vote(p, 'up')" :disabled="voteBusy === p.id" title="Upvote">
            <i class="mdi mdi-arrow-up-bold"></i>
          </button>
          <span class="ft-vote-count">{{ Number(p.upvote_count||0) - Number(p.downvote_count||0) }}</span>
          <button class="ft-vote-btn" :class="{down: voteState[p.id] === 'down'}" @click="vote(p, 'down')" :disabled="voteBusy === p.id" title="Downvote">
            <i class="mdi mdi-arrow-down-bold"></i>
          </button>
        </div>
        <div style="flex:1;min-width:0;">
          <div class="ft-post-author">
            <user-avatar :src="p.author_avatar" :name="p.author_name" size="sm" :badge="p.author_is_vet == 1 ? 'vet' : ''" />
            <div>
              <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;">
                {{ p.author_name && p.author_name.trim() ? p.author_name : 'Anonymous' }}
                <span v-if="p.author_is_vet == 1" class="ft-vet-badge" title="Verified veterinarian"><i class="mdi mdi-stethoscope"></i> Vet</span>
                <span v-if="p.is_vet_verified == 1" class="ft-verified-badge" title="Vet-verified answer"><i class="mdi mdi-check-circle"></i> Vet-verified</span>
                <span v-if="p.is_accepted_answer == 1" class="ft-accepted-badge" title="Accepted answer"><i class="mdi mdi-check-decagram"></i> Accepted</span>
              </div>
              <div style="color:var(--fm-s,#6B6356);font-size:10px;">{{ p.created_at }}</div>
            </div>
          </div>
          <div class="ft-post-content">{{ p.content }}</div>

          <!-- Post media (images + videos) -->
          <div v-if="postVisualMedia(p).length" class="ft-media-grid">
            <div v-for="(m, mi) in postVisualMedia(p)" :key="'pm-'+p.id+'-'+mi" class="ft-media-display">
              <img v-if="m.type === 'image'" :src="mediaUrl(m.url)" @click="openLightbox(m)" />
              <video v-else :src="mediaUrl(m.url)" controls></video>
            </div>
          </div>
          <!-- Post documents -->
          <div v-if="postDocs(p).length" class="ft-doc-list">
            <a v-for="(d, di) in postDocs(p)" :key="'pd-'+p.id+'-'+di" :href="mediaUrl(d.url)" target="_blank" class="ft-doc-link">
              <i class="mdi" :class="docIcon(d.name || d.url)"></i>
              <div style="flex:1;min-width:0;">
                <div class="ft-doc-link-name">{{ d.name || 'Document' }}</div>
                <div class="ft-doc-link-size" v-if="d.size">{{ humanSize(d.size) }}</div>
              </div>
              <i class="mdi mdi-download" style="color:var(--fm-s,#6B6356);"></i>
            </a>
          </div>

          <div v-if="p.location_label" class="ft-post-loc">
            <i class="mdi mdi-map-marker me-1"></i>From {{ p.location_label }}
          </div>

          <div class="ft-post-actions" v-if="!isMyTopic && (canVerify || canAccept(p))">
            <button v-if="canAccept(p)" class="btn btn-sm btn-outline-success" @click="acceptAnswer(p)" :disabled="acceptBusy">
              <i class="mdi mdi-check-decagram me-1"></i>Mark as accepted answer
            </button>
            <button v-if="canVerify && p.is_vet_verified != 1" class="btn btn-sm btn-outline-info" @click="verifyPost(p)">
              <i class="mdi mdi-stethoscope me-1"></i>Mark as vet-verified
            </button>
          </div>
        </div>
      </div>

      <!-- Reply form -->
      <div v-if="topic.status !== 'closed'" class="ft-reply-form">
        <h6 style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-pencil me-1"></i>Write a reply</h6>
        <textarea v-model="replyContent" class="form-control ft-input" rows="4" placeholder="Share your experience, ask a follow-up, or offer advice..."></textarea>

        <!-- Media (photos / video / documents) -->
        <div class="ft-media-row">
          <template v-for="(m, mi) in replyMedia" :key="mi">
            <div v-if="m.type !== 'document'" class="ft-media-thumb">
              <img v-if="m.type === 'image'" :src="m.preview" />
              <video v-else :src="m.preview" muted></video>
              <button class="ft-media-remove" @click="removeReplyMedia(mi)" type="button"><i class="mdi mdi-close"></i></button>
              <span v-if="m.type === 'video'" class="ft-media-badge"><i class="mdi mdi-video"></i></span>
            </div>
            <div v-else class="ft-doc-chip">
              <i class="mdi" :class="docIcon(m.name)" style="font-size:20px;color:#BFA164;"></i>
              <div class="ft-doc-info">
                <div class="ft-doc-name">{{ m.name }}</div>
                <div class="ft-doc-size">{{ humanSize(m.file ? m.file.size : 0) }}</div>
              </div>
              <button class="ft-doc-remove" @click="removeReplyMedia(mi)" type="button"><i class="mdi mdi-close"></i></button>
            </div>
          </template>
          <label v-if="replyMedia.length < 6 && !replyCompressing" class="ft-media-add">
            <input type="file" accept="image/*,video/mp4,video/quicktime,video/webm,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" multiple @change="onReplyMediaPick" />
            <i class="mdi mdi-paperclip" style="font-size:22px;"></i>
            <span>Add</span>
          </label>
          <div v-if="replyCompressing" class="ft-media-add" style="pointer-events:none;">
            <span class="spinner-border spinner-border-sm text-warning"></span>
          </div>
        </div>

        <!-- Location -->
        <div class="ft-loc-row">
          <label class="ft-loc-label">
            <input type="checkbox" v-model="replyShareLocation" @change="onReplyLocationToggle" />
            <i class="mdi mdi-map-marker me-1" style="color:#50C878;"></i>
            <span v-if="replyLocationLabel">From <strong style="color:#50C878;">{{ replyLocationLabel }}</strong></span>
            <span v-else-if="replyLocationBusy"><span class="spinner-border spinner-border-sm me-1"></span>Detecting...</span>
            <span v-else>Share my location</span>
          </label>
          <span v-if="replyLocationError" style="font-size:11px;color:#FF6B6B;margin-left:8px;">{{ replyLocationError }}</span>
        </div>

        <div v-if="replyError" class="text-danger" style="font-size:12px;margin-top:6px;">{{ replyError }}</div>
        <button class="btn btn-warning mt-2" @click="submitReply" :disabled="replyBusy || !replyContent.trim()">
          <span v-if="replyBusy" class="spinner-border spinner-border-sm me-1"></span>
          <i v-else class="mdi mdi-send me-1"></i>Post Reply
        </button>
      </div>
      <div v-else class="ft-closed-banner">
        <i class="mdi mdi-lock me-1"></i>This topic is closed for new replies.
      </div>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important}
html[data-theme="light"] .ft-root{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .ft-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .ft-topic,
html[data-theme="light"] .ft-post,
html[data-theme="light"] .ft-reply-form{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .ft-input{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
</style>

<style scoped>
.ft-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.ft-topbar{position:sticky;top:0;z-index:100;padding:10px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.ft-container{padding-top:80px;padding-bottom:60px;max-width:820px}

.ft-topic{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:22px;margin-bottom:20px}
.ft-cat-row{display:flex;flex-wrap:wrap;gap:6px;align-items:center;margin-bottom:8px}
.ft-cat{display:inline-block;padding:3px 10px;border-radius:6px;background:rgba(191,161,100,.12);color:#BFA164;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px}
.ft-pin{font-size:10px;color:#BFA164;background:rgba(191,161,100,.08);padding:2px 8px;border-radius:6px}
.ft-closed{font-size:10px;color:#FF6B6B;background:rgba(255,107,107,.08);padding:2px 8px;border-radius:6px}
.ft-answered{font-size:10px;color:#50C878;background:rgba(80,200,120,.08);padding:2px 8px;border-radius:6px}
.ft-title{color:var(--fm-h,#F5F0E8);font-weight:700;line-height:1.3;margin-bottom:14px}
.ft-author{display:flex;gap:10px;align-items:center;margin-bottom:14px}
.ft-avatar{width:38px;height:38px;border-radius:50%;background:var(--fm-bg3,#1E1E1E);display:flex;align-items:center;justify-content:center;font-weight:700;color:#BFA164;overflow:hidden;flex-shrink:0}
.ft-avatar img{width:100%;height:100%;object-fit:cover}
.ft-avatar-sm{width:32px;height:32px;font-size:13px}
.ft-content{color:var(--fm-h,#F5F0E8);font-size:14px;line-height:1.7;white-space:pre-wrap}
.ft-stats{display:flex;gap:18px;font-size:11px;color:var(--fm-s,#6B6356);margin-top:14px;padding-top:12px;border-top:1px dashed var(--fm-br,#1E1E1E)}

.ft-post{display:flex;gap:14px;background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:18px;margin-bottom:10px}
.ft-post.accepted{border-color:rgba(80,200,120,.4);background:rgba(80,200,120,.04)}
.ft-vote{display:flex;flex-direction:column;align-items:center;gap:4px;flex-shrink:0}
.ft-vote-btn{width:28px;height:28px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg2,#0F0F0F);color:var(--fm-s,#6B6356);border-radius:6px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .15s}
.ft-vote-btn:hover{border-color:#BFA164;color:#BFA164}
.ft-vote-btn.up{background:rgba(80,200,120,.12);border-color:#50C878;color:#50C878}
.ft-vote-btn.down{background:rgba(255,107,107,.12);border-color:#FF6B6B;color:#FF6B6B}
.ft-vote-count{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:13px}
.ft-post-author{display:flex;gap:10px;align-items:center;margin-bottom:10px}
.ft-vet-badge,.ft-verified-badge,.ft-accepted-badge{display:inline-block;font-size:9px;padding:1px 6px;border-radius:6px;margin-left:4px;font-weight:600;letter-spacing:.3px}
.ft-vet-badge{background:rgba(79,195,247,.12);color:#4FC3F7}
.ft-verified-badge{background:rgba(79,195,247,.12);color:#4FC3F7}
.ft-accepted-badge{background:rgba(80,200,120,.12);color:#50C878}
.ft-post-content{color:var(--fm-h,#F5F0E8);font-size:13px;line-height:1.7;white-space:pre-wrap}
.ft-post-actions{display:flex;gap:6px;margin-top:10px;flex-wrap:wrap}

.ft-reply-form{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:18px;margin-top:24px}
.ft-input{background:var(--fm-bg2,#0F0F0F)!important;border:1px solid var(--fm-br,#1E1E1E)!important;color:var(--fm-h,#F5F0E8)!important;font-size:13px}
.ft-closed-banner{margin-top:24px;padding:14px;background:rgba(255,107,107,.06);border:1px solid rgba(255,107,107,.2);border-radius:10px;color:#FF6B6B;font-size:13px;text-align:center}

/* Reply media picker */
.ft-media-row{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}
.ft-media-thumb{position:relative;width:74px;height:74px;border-radius:8px;overflow:hidden;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E)}
.ft-media-thumb img,.ft-media-thumb video{width:100%;height:100%;object-fit:cover}
.ft-media-remove{position:absolute;top:2px;right:2px;width:20px;height:20px;border-radius:50%;background:rgba(0,0,0,.7);border:none;color:#FF6B6B;font-size:12px;cursor:pointer;display:flex;align-items:center;justify-content:center}
.ft-media-badge{position:absolute;bottom:3px;left:3px;background:rgba(0,0,0,.7);color:#FFD700;font-size:9px;padding:1px 5px;border-radius:5px}
.ft-media-add{width:74px;height:74px;border-radius:8px;border:2px dashed var(--fm-br,#1E1E1E);background:var(--fm-bg2,#0F0F0F);display:flex;flex-direction:column;align-items:center;justify-content:center;cursor:pointer;color:var(--fm-s,#6B6356);font-size:9px}
.ft-media-add:hover{border-color:#BFA164;color:#BFA164}
.ft-media-add input{display:none}

/* Document chip in the picker */
.ft-doc-chip{display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:8px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg2,#0F0F0F);min-width:140px;max-width:220px;height:74px;position:relative}
.ft-doc-info{flex:1;min-width:0}
.ft-doc-name{color:var(--fm-h,#F5F0E8);font-weight:600;font-size:11px;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ft-doc-size{color:var(--fm-s,#6B6356);font-size:10px}
.ft-doc-remove{position:absolute;top:3px;right:3px;width:18px;height:18px;border-radius:50%;background:rgba(0,0,0,.4);border:none;color:#FF6B6B;font-size:11px;cursor:pointer;display:flex;align-items:center;justify-content:center}

/* Document downloads on rendered topic / posts */
.ft-doc-list{display:flex;flex-direction:column;gap:6px;margin:10px 0}
.ft-doc-link{display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;color:var(--fm-h,#F5F0E8);text-decoration:none;font-size:13px;transition:border-color .15s}
.ft-doc-link:hover{border-color:#BFA164}
.ft-doc-link i{font-size:22px;color:#BFA164;flex-shrink:0}
.ft-doc-link-name{font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ft-doc-link-size{font-size:10px;color:var(--fm-s,#6B6356)}

/* Inline media on topic + posts */
.ft-media-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:8px;margin:12px 0}
.ft-media-display{aspect-ratio:1;border-radius:8px;overflow:hidden;background:var(--fm-bg2,#0F0F0F)}
.ft-media-display img,.ft-media-display video{width:100%;height:100%;object-fit:cover;display:block;cursor:pointer}

/* Location row */
.ft-loc-row{margin-top:10px;padding:8px 12px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px}
.ft-loc-label{display:flex;align-items:center;gap:8px;cursor:pointer;font-size:12px;color:var(--fm-m,#A09888);margin:0}
.ft-loc-label input[type="checkbox"]{accent-color:#50C878;width:15px;height:15px;cursor:pointer}

.ft-post-loc{margin-top:6px;font-size:11px;color:#50C878}
</style>

<script>
/* eslint-disable */
import { execute, executeJson, flocker, uploads } from "@/api";
import UserAvatar from "@/components/flockr-users/UserAvatar.vue";

function compressImage(file, maxDim, quality){
  return new Promise(function(resolve){
    var reader = new FileReader();
    reader.onload = function(e){
      var img = new Image();
      img.onload = function(){
        var w = img.width, h = img.height;
        if (w > maxDim || h > maxDim) {
          if (w > h) { h = Math.round(h * maxDim / w); w = maxDim; }
          else       { w = Math.round(w * maxDim / h); h = maxDim; }
        }
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        canvas.toBlob(function(blob){
          if (!blob) { resolve({ file: file, preview: e.target.result }); return; }
          var emit = function(b){
            var name = file.name.replace(/\.[^.]+$/, '.jpg');
            var f = new File([b], name, { type: 'image/jpeg' });
            resolve({ file: f, preview: URL.createObjectURL(f) });
          };
          if (blob.size > 2 * 1024 * 1024) {
            canvas.toBlob(function(b2){ emit(b2 || blob); }, 'image/jpeg', 0.6);
          } else { emit(blob); }
        }, 'image/jpeg', quality);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}

export default {
  name: "ForumTopicDetail",
  components: { UserAvatar },
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,loading:true,
    topic: null, posts: [],
    replyContent: '', replyBusy: false, replyError: '',
    replyMedia: [], replyCompressing: false,
    replyShareLocation: false, replyLocationLabel: '', replyLocationLat: null, replyLocationLng: null, replyLocationBusy: false, replyLocationError: '',
    voteState: {}, voteBusy: '',
    acceptBusy: false
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    isMyTopic(){return this.topic && this.topic.author_id === sessionStorage.getItem('userId');},
    canVerify(){
      try{var roles=JSON.parse(sessionStorage.getItem('userRoles')||'[]'); return roles.indexOf('vet')>-1;}catch(e){return false}
    },
    topicMedia(){
      if (!this.topic || !this.topic.photos) return [];
      try {
        var arr = typeof this.topic.photos === 'string' ? JSON.parse(this.topic.photos) : this.topic.photos;
        return Array.isArray(arr) ? arr.filter(function(m){return m && m.url;}) : [];
      } catch(e){ return []; }
    },
    topicVisualMedia(){ return this.topicMedia.filter(function(m){ return m.type !== 'document'; }); },
    topicDocs(){ return this.topicMedia.filter(function(m){ return m.type === 'document'; }); }
  },
  watch: {
    '$route.params.id'(){this.load()}
  },
  mounted(){
    this._applyThemeOnce();
    var self=this;
    this.themeObserver=new MutationObserver(function(){try{self._applyThemeOnce();}catch(e){}});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    this.load();
  },
  beforeUnmount(){if(this.themeObserver){this.themeObserver.disconnect();this.themeObserver=null}},
  methods:{
    _applyThemeOnce(){
      var current=document.documentElement.getAttribute('data-theme');
      var desired=(localStorage.getItem('flockr_theme')||current||'dark');
      if(current!==desired) document.documentElement.setAttribute('data-theme',desired);
      this.darkMode=desired!=='light';
    },
    canAccept(p){
      // Topic author can accept any non-self answer if topic isn't already answered
      return this.isMyTopic && p.author_id !== sessionStorage.getItem('userId') && this.topic.is_answered != 1;
    },
    async load(){
      this.loading=true;
      var topicId=this.$route.params.id;
      try{
        var r=await executeJson({function:'getForumTopicDetail',topicId:topicId},flocker);
        if(r.data&&r.data.success&&r.data.data){
          this.topic=r.data.data.topic;
          this.posts=r.data.data.posts||[];
        }
      }catch(e){console.error(e)}
      this.loading=false;
    },
    async vote(p, type){
      var userId=sessionStorage.getItem('userId');
      if(!userId){this.$router.push('/login?redirect=/forum/'+this.topic.id);return}
      this.voteBusy=p.id;
      // Toggle: clicking the same vote clears it
      var current = this.voteState[p.id];
      var newType = current === type ? 'clear' : type;
      try{
        var r=await executeJson({function:'voteForumPost',userId:userId,postId:p.id,voteType:newType},flocker);
        if(r.data&&r.data.success){
          if(newType==='clear') delete this.voteState[p.id]; else this.voteState[p.id] = newType;
          if(r.data.data){
            p.upvote_count = r.data.data.upvote_count;
            p.downvote_count = r.data.data.downvote_count;
          }
        }
      }catch(e){}
      this.voteBusy='';
    },
    mediaUrl(u){ if(!u) return ''; if(u.indexOf('http')===0) return u; return uploads + String(u).replace(/^uploads\//, ''); },
    postMedia(p){
      if (!p || !p.photos) return [];
      try {
        var arr = typeof p.photos === 'string' ? JSON.parse(p.photos) : p.photos;
        return Array.isArray(arr) ? arr.filter(function(m){return m && m.url;}) : [];
      } catch(e){ return []; }
    },
    postVisualMedia(p){ return this.postMedia(p).filter(function(m){ return m.type !== 'document'; }); },
    postDocs(p){ return this.postMedia(p).filter(function(m){ return m.type === 'document'; }); },
    openLightbox(m){
      // Simplest possible: open in new tab
      window.open(this.mediaUrl(m.url), '_blank');
    },
    async onReplyMediaPick(event){
      var self = this;
      var files = Array.from(event.target.files || []);
      var slots = 6 - this.replyMedia.length;
      if (slots <= 0) { event.target.value=''; return; }
      var picked = files.slice(0, slots);
      this.replyCompressing = true;
      try {
        for (var i = 0; i < picked.length; i++) {
          var f = picked[i];
          if (f.type.indexOf('image/') === 0) {
            var c = await compressImage(f, 1200, 0.8);
            this.replyMedia.push({ type:'image', file: c.file, preview: c.preview });
          } else if (f.type.indexOf('video/') === 0) {
            if (f.size > 25 * 1024 * 1024) {
              this.replyError = 'Videos must be under 25 MB.';
              continue;
            }
            this.replyMedia.push({ type:'video', file: f, preview: URL.createObjectURL(f) });
          } else if (this.isDocFile(f)) {
            if (f.size > 10 * 1024 * 1024) {
              this.replyError = 'Documents must be under 10 MB.';
              continue;
            }
            this.replyMedia.push({ type:'document', file: f, name: f.name, preview: '' });
          } else {
            this.replyError = 'Unsupported file: ' + (f.name || 'file');
          }
        }
      } catch(e){ this.replyError = 'Could not process file'; }
      this.replyCompressing = false;
      event.target.value = '';
    },
    isDocFile(f){
      var allowedMime = ['application/pdf','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-powerpoint','application/vnd.openxmlformats-officedocument.presentationml.presentation','text/plain','text/csv'];
      var allowedExt = /\.(pdf|docx?|xlsx?|pptx?|txt|csv)$/i;
      return allowedMime.indexOf(f.type) > -1 || allowedExt.test(f.name || '');
    },
    docIcon(name){
      var n = (name || '').toLowerCase();
      if (n.indexOf('.pdf') > -1) return 'mdi-file-pdf-box';
      if (/\.docx?$/.test(n)) return 'mdi-file-word-box';
      if (/\.xlsx?$/.test(n) || n.indexOf('.csv') > -1) return 'mdi-file-excel-box';
      if (/\.pptx?$/.test(n)) return 'mdi-file-powerpoint-box';
      if (n.indexOf('.txt') > -1) return 'mdi-file-document-outline';
      return 'mdi-file-outline';
    },
    humanSize(b){
      b = Number(b||0); if (b < 1024) return b + ' B';
      if (b < 1024*1024) return (b/1024).toFixed(1) + ' KB';
      return (b/1024/1024).toFixed(1) + ' MB';
    },
    removeReplyMedia(idx){
      var m = this.replyMedia[idx];
      if (m && m.preview && m.preview.indexOf('blob:') === 0) URL.revokeObjectURL(m.preview);
      this.replyMedia.splice(idx, 1);
    },
    onReplyLocationToggle(){
      var self = this;
      if (!this.replyShareLocation) {
        this.replyLocationLabel=''; this.replyLocationLat=null; this.replyLocationLng=null; this.replyLocationError='';
        return;
      }
      if (!navigator.geolocation) {
        this.replyShareLocation = false;
        this.replyLocationError = 'Geolocation not supported';
        return;
      }
      this.replyLocationBusy = true; this.replyLocationError = '';
      navigator.geolocation.getCurrentPosition(async function(pos){
        self.replyLocationLat = pos.coords.latitude;
        self.replyLocationLng = pos.coords.longitude;
        try {
          var url = 'https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=' + self.replyLocationLat + '&lon=' + self.replyLocationLng + '&zoom=8';
          var resp = await fetch(url, { headers: { 'Accept-Language': 'en' } });
          var data = await resp.json();
          var a = data.address || {};
          var parts = [a.city || a.town || a.village || a.county || a.state_district || a.state, a.country];
          self.replyLocationLabel = parts.filter(Boolean).join(', ') || data.display_name || ('GPS ' + self.replyLocationLat.toFixed(2) + ', ' + self.replyLocationLng.toFixed(2));
        } catch(e){
          self.replyLocationLabel = 'GPS ' + self.replyLocationLat.toFixed(2) + ', ' + self.replyLocationLng.toFixed(2);
        }
        self.replyLocationBusy = false;
      }, function(err){
        self.replyLocationBusy = false;
        self.replyShareLocation = false;
        self.replyLocationError = err && err.code === 1 ? 'Permission denied' : 'Could not detect location';
      }, { timeout: 8000, enableHighAccuracy: false });
    },
    async submitReply(){
      var userId=sessionStorage.getItem('userId');
      if(!userId){this.$router.push('/login?redirect=/forum/'+this.topic.id);return}
      this.replyBusy=true; this.replyError='';
      try{
        var fd = new FormData();
        fd.append('function','replyToForumTopic');
        fd.append('userId', userId);
        fd.append('topicId', this.topic.id);
        fd.append('content', this.replyContent);
        if (this.replyShareLocation && this.replyLocationLat) {
          fd.append('locationLabel', this.replyLocationLabel || '');
          fd.append('locationLat', String(this.replyLocationLat));
          fd.append('locationLng', String(this.replyLocationLng));
        }
        var pi = 0;
        this.replyMedia.forEach(function(m){
          if (m.file) { fd.append('photo' + pi, m.file); pi++; }
        });
        var r = await execute(fd, flocker);
        if(r.data&&r.data.success){
          this.replyContent='';
          this.replyMedia = [];
          this.replyShareLocation = false;
          this.replyLocationLabel = ''; this.replyLocationLat = null; this.replyLocationLng = null;
          await this.load();
        }else{
          this.replyError=(r.data&&r.data.message)||'Could not post reply';
        }
      }catch(e){this.replyError=(e&&e.message)||'Network error'}
      this.replyBusy=false;
    },
    async acceptAnswer(p){
      if(!confirm("Mark this reply as the accepted answer? The topic will be marked answered.")) return;
      this.acceptBusy=true;
      try{
        var r=await executeJson({
          function:'acceptForumAnswer',
          userId: sessionStorage.getItem('userId'),
          topicId: this.topic.id,
          postId: p.id
        },flocker);
        if(r.data&&r.data.success) await this.load();
      }catch(e){}
      this.acceptBusy=false;
    },
    async verifyPost(p){
      try{
        var r=await executeJson({
          function:'verifyForumPost',
          userId: sessionStorage.getItem('userId'),
          postId: p.id
        },flocker);
        if(r.data&&r.data.success) p.is_vet_verified = 1;
      }catch(e){}
    }
  }
};
</script>
